var StyleProductCreateModal = (function (backOffice, $) {
    backOffice.StyleProductCreateModal = (function () {

    var modalSelector = '#styleProductCreateModal';
    var accessRestrictedModalSelector = '#style_product_create_access_restricted_modal';
    var accessDeniedCreateProductAttributeModalSelector = '#create_product_attribute_access_restricted'
    var shortDescription = '#SShort_Description';
    var manufacturerSKU = '#SManufacturer_Product_ID';
    var productTypesSelect = '#SProductTypes';
    var supplierBuyEx = '#SSupplier_Buy';
    var priceEx = '#SPrice_Ex';
    var directCostsEx = '#SDirect_Costs';
    var cogsEx = '#SCost_Of_Goods_Sold';
    var markupTargetRadio = '#SPOSPricingByMarkupTarget';
    var markupTarget = '#SPOSPriceMarkupTarget';
    var fixedPriceRadio = '#SPOSPricingByPrice';
    var fixedPrice = '#SPrice_POS';
    var selectedColoursListbox = '#lbColoursSelection';
    var selectedSizesListbox = '#lbSizesSelection';
    var addVariantsStep = '.addVariantsStep';
    var configureStylesStep = '.configureStylesStep';
    var additionalDetailsStep = '.additionalDetailsStep';
    var brandsSelect = '#SBrands';
    var seasonsSelect = '#SSeasons';
    var suppliersSelect = '#SSuppliers';
    var lbColoursId = 'lbColours';
    var lbSizesId = 'lbSizes';
    var addNewColourBtn = '#NewColourBtn';
    var addNewSizeBtn = '#NewSizeBtn';
    var coloursFilterInput = '#ttfInputColours';
    var sizesFilterInput = '#ttfInputSizes';
    var customAttributesTable = '#CustomAttributesTable';
    var addVariantsGridBodyId = '#addVariantsGridBodyId';
    var publishToShopifyTableSelector = '#publishToShopifyTable';
    var publishToShopifyContainerSelector = '#publishToShopifyContainer';
    var additionalDetailsPropertiesTableSelector = '#additionalDetailsPropertiesTable';


    //additional details inputs
    var supplierSKU2 = '#SupplierSKU2';
    var custom1 = '#Custom1';
    var custom2 = '#Custom2';
    var custom3 = '#Custom3';
    var weight = '#Weight';
    var length = '#Length';
    var breadth = '#Breadth';
    var depth = '#Depth';
    var shippingCubic = '#ShippingCubic';
    var disabled = '#Disabled';
    var rRP = '#RRP';
    var webPrice = '#WebPrice';

    var variantsPatternSelect = '#SVariantDescriptionPattern';
    var addVariantsValidationSectionSelector = '#add-variants-validation-section'
    var addVariantsSupplierBuyExClassSelector = ".add-variants-supplier-buy-ex"

    var baseApiPath = window.location.origin + '/dotnet/admin/api/';

    var selectHiddenInputSuffix = "SelectedValue";

    var currentDateTimeString = '';

    //any decimal value and 0
    var regExMoney = new RegExp("^([0-9]+(?:[.][0-9]*)?|[.][0-9]+)$");

    var products = [];

    var columnIndexes = {
        IsSelected: 0,
        Colour: 1,
        Size: 2,
        SupplierSKU: 3,
        ShortDescription: 4,
        SupplierBuyEx: 5,
        SellPriceInc: 6
     }

    var barcodesFeatureEnabled = false
    var defaultTaxRate = 0
    const DEFAULT_ID = 0;
    const DEFAULT_ATTR_OPTION_NAME = 'None';

    $(document).off('change', markupTargetRadio).on('change', markupTargetRadio, function () {
        if (this.checked) {
            $(fixedPrice).val('');
            $(fixedPrice).prop("readonly", true);
            $(markupTarget).prop("readonly", false);
            $(markupTarget).parents('tr').addClass("IsRequired")
            $(fixedPrice).parents('tr').removeClass("IsRequired")
        }
    });

    $(document).off('change', fixedPriceRadio).on('change', fixedPriceRadio, function () {
        if (this.checked) {
            $(markupTarget).val('');
            $(fixedPrice).prop("readonly", false);
            $(markupTarget).prop("readonly", true);
            $(markupTarget).parents('tr').removeClass("IsRequired")
            $(fixedPrice).parents('tr').addClass("IsRequired")
        }
    });

    var radBoxSortImpl = function (controlId, filterInput) {
        var control = $find(controlId);
        if (!control) {
            return;
        }

        var itemsArr = control.get_items().toArray();
        itemsArr.sort(function (a, b) {
            var aText = a.get_text().toUpperCase();
            var bText = b.get_text().toUpperCase();
            var aOrder = a.sortOrder || Number.MAX_SAFE_INTEGER;
            var bOrder = b.sortOrder || Number.MAX_SAFE_INTEGER;

            if (aOrder !== bOrder) {
                return aOrder - bOrder;
            }

            if (aText === bText) {
                return 0;
            }

            return aText < bText ? -1 : 1;
        });

        var count = control.get_items().get_count();
        control.beginUpdate();
        for (var i = 0; i < count; i++) {
            var lastItem = control.getLastItem();
            control.get_items().remove(lastItem);
        }

        for (var i = 0; i < itemsArr.length; i++) {
            control.get_items().add(itemsArr[i]);
        }

        control.commitChanges();
        filterListBox(controlId, $(filterInput).val());
    }

    function sortSizes() {
        radBoxSortImpl(lbSizesId, sizesFilterInput)
    }

    function sortColours() {
        radBoxSortImpl(lbColoursId, coloursFilterInput)
    }

    var init = function (options) {
        $.extend(backOffice.options, options);
    }

    var open = function (taxRate, barcodesEnabled) {
        bindWindowEventHandlers();
        defaultTaxRate = taxRate || 0;
        
        barcodesFeatureEnabled = barcodesEnabled
        
        if (BackOffice.options.userPermissions.userHasEditProductPermission) {
            openConfigureStylesStep();
            setDefaultValues();
            $(modalSelector).modal('show');
            configureCreateStyleModalValidation();
        }
        else {
            $(accessRestrictedModalSelector).modal('show');
        }
        
        Telerik.Web.UI.RadListBox.prototype.saveClientState = function () {
            return "{" +
                "\"isEnabled\":" + this._enabled +
                ",\"logEntries\":" + this._logEntriesJson +
                ",\"selectedIndices\":" + this._selectedIndicesJson +
                ",\"checkedIndices\":" + this._checkedIndicesJson +
                ",\"scrollPosition\":" + Math.round(this._scrollPosition) +
                "}";
        }
        
        return false;
    };

    var setDefaultValues = function () {
        $(variantsPatternSelect).prop("selectedIndex", 0);
        $(fixedPriceRadio).prop("checked", true);
        $(fixedPriceRadio).trigger("change");
    }

    var close = function () {
        BackOffice.Utils.RedirectTo("/DOTNET/ADMIN/day_diary.aspx");

        window.beforeunload = null;
    };

    var validateStyleConfiguration = function () {
        var msg = "";
        if ($(shortDescription).val() === "") {
            msg += "Please enter a Short Description\n";
        }
        if (BackOffice.ContainHtml($(shortDescription).val())) {
            msg += "Please remove HTML code from Short Description\n";
        }

        if ($(manufacturerSKU).val() === "") {
            msg += "Please enter a Manufacturer SKU\n";
        }

        if (BackOffice.ContainHtml($(manufacturerSKU).val())) {
            msg += "Please remove HTML code from Manufacturer SKU\n";
        }

        if ($(manufacturerSKU)[0].IsUnique == null) {
            $(manufacturerSKU).blur();
        }

        if ($(productTypesSelect + " option:selected").val() === "") {
            msg += "Please select a Product Type\n";
        }

        if (!$(suppliersSelect + " option:selected").val()) {
            msg += "Please select a Supplier\n";
        }

        if ($(fixedPriceRadio + ":checked").length > 0) {
            if ($(fixedPrice).val() === "") {
                msg += "Please enter a Sell Price Inc\n";
            }
            if (!regExMoney.test($(fixedPrice).val())) {
                msg += "Sell Price Inc must be a positive number\n";
            }
        }

        if ($(markupTargetRadio + ":checked").length > 0) {
            if ($(markupTarget).val() == "") {
                msg += "Please enter Markup Target %\n";
            }
            if (!regExMoney.test($(markupTarget).val())) {
                msg += "Markup Target must be a positive number\n";
            }
        }

        if ($(supplierBuyEx).val()) {
            if (!regExMoney.test($(supplierBuyEx).val())) {
                msg += "Supplier Buy Ex must be a positive number\n";
            }
            else if ($(supplierBuyEx).val() > 99999999999999) {
                msg += "Invalid Supplier Buy Ex - Exceeds Maximum Supported Value\n"
            }
        }

        if ($(priceEx).val() === "") {
            msg += "Please enter a Buy Ex\n";
        } else if (!regExMoney.test($(priceEx).val())) {
            msg += "Buy Ex must be a positive number\n";
        } else if ($(priceEx).val() > 99999999999999) {
            msg += "Invalid Buy Ex - Exceeds Maximum Supported Value\n"
        }

        if ($(directCostsEx).val()) {
            if (!regExMoney.test($(directCostsEx).val())) {
                msg += "Direct Costs must be a positive number\n";
            }
            else if ($(directCostsEx).val() > 99999999999999) {
                msg += "Invalid Direct Costs - Exceeds Maximum Supported Value\n"
            }
        }

        msg += validateSelectedColourAndSizeVariants();
        
        if (msg) {
            alert(msg);
            return false;
        }
        snapshotDropdownSelectedValues();

        return true;
    };

    function validateSelectedColourAndSizeVariants() {
        var errors = '';
        var selectedColours = getSelectedColours();
        var selectedSizes = getSelectedSizes();

        var numberOfVariantsIsLessThanMaxAllowed =
            selectedColours.length > 100
            || selectedSizes.length > 100
            || selectedColours.length * selectedSizes.length > 100

        var numberOfVariantsIsLessThanMinAllowed = (selectedColours.length === 0 || selectedSizes.length === 0)
            || (selectedColours.length === 1 && selectedColours[0].value === DEFAULT_ID
                && selectedSizes.length === 1 && selectedSizes[0].value === DEFAULT_ID);

        if (numberOfVariantsIsLessThanMinAllowed) {
            errors += "At least one Colour OR Size must be selected to create Style/Matrix products. Please select at least one Size or Colour, other than “None” to continue.\n";
        }

        if (numberOfVariantsIsLessThanMaxAllowed) {
            errors += "Maximum variants for a Style is 100. Please reduce the number of attribute values and try again.\n";
        }

        return errors;
    }

    var getSelectedColours = function () {
        return getSelectedColoursElements()
                 .map(function (item) { return { type: 'colour', text: item._properties._data.text, value: item._properties._data.value } })
                 .sort(function (a, b) {
                     if (a.text.toUpperCase() < b.text.toUpperCase()) {
                         return -1;
                     }
                     if (a.text.toUpperCase() > b.text.toUpperCase()) {
                         return 1;
                     }
                     return 0;
                 });
    }

    function getSelectedColoursElements() {
        return getSelectedElements('lbColoursSelection');
    }
    
    var getSelectedSizes = function () {
        return getSelectedSizesElements()
                .sort(function (a, b) { return a.sortOrder - b.sortOrder })
                .map(function (item) { return { type: 'size', text: item._properties._data.text, value: item._properties._data.value } });
    }

    function getSelectedSizesElements() {
        return getSelectedElements('lbSizesSelection');
    }

    function getSelectedElements(selector) {
        return $find(selector)
            .get_items()
            ._array;
    }

    function resolveShortDescription(name, colour, size) {
        colour = getDescriptionValue(colour);
        size = getDescriptionValue(size);
        name = name.trim();

        switch (parseInt($(variantsPatternSelect).val())) {
            case 1: // Short Description + Colour + Size
                return name + colour + size;
            case 2: // Short Description + Size + Colour
                return name + size + colour;
            case 3: // Short Description + Colour
                return name + colour
            case 4: // Short Description + Size
                return name + size;
            default: // Short Description
                return name;
        }
    }

    function getDescriptionValue(value) {
        if (value) {
           return ' ' + value.trim();
        }
        else {
           return '';
        }
    }

    function getAttributeDescriptionName(attrName) {
        return attrName === DEFAULT_ATTR_OPTION_NAME ? '' : attrName;
    }

    function validateManSKU() {
        var duplicatedManSKUConfirmed = true;

        if ($(manufacturerSKU)[0].IsUnique === "false") {
            duplicatedManSKUConfirmed = confirm("The Manufacturer SKU already exists against some product/s.\nProceeding may result in creating duplicate variant products.");
        }

        return duplicatedManSKUConfirmed;
    }

    function htmlEncode(str) {
            return str
                .replace(/&/g, "&amp;")
                .replace(/'/g, "&#39;")
                .replace(/"/g, "&quot;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/\//g, "&#47;");
    }

    var loadConfigureVariantsStep = function () {
        if (validateStyleConfiguration() && validateManSKU()) {
            openAddVariantsStep();

            $(addVariantsGridBodyId).html('');

            // build grid
            var gridContent = '<tr><th scope="col">&nbsp;</th><th scope="col">Colour</th><th scope="col">Size</th><th scope="col">Supplier SKU</th><th scope="col">Short Description</th><th scope="col">Supplier Buy Ex</th><th scope="col">Sell Price Inc</th></tr>';

            var selectedColours = getSelectedColours();

            if (selectedColours.length > 1) {
                selectedColours = selectedColours.filter(c => c.value !== DEFAULT_ID);
            }

            var selectedSizes = getSelectedSizes();

            if (selectedSizes.length > 1) {
                selectedSizes = selectedSizes.filter(s => s.value !== DEFAULT_ID);
            }

            var variants = [];
            for (var i = 0; i < selectedColours.length; i++) {
                for (var j = 0; j < selectedSizes.length; j++) {
                    variants.push({
                        colour: selectedColours[i],
                        size: selectedSizes[j]
                    })
                }
            }

            // rows
            for (var i = 0; i < variants.length; i++) {

                var currentVariant = variants[i];

                gridContent += '<tr class="color-size-combination-row">';

                // columns
                gridContent += '<td style="width:4%;">';
                var checkBoxId = 'VariantIsSelected_' + i;
                gridContent += '<input id="' + checkBoxId + '" type="checkbox" name="' + checkBoxId + '" checked="checked" />'
                gridContent += '<input type="hidden" value="' + currentVariant.colour.value + '" />'
                gridContent += '<input type="hidden" value="' + currentVariant.size.value + '" />'
                gridContent += '</td>';

                gridContent += '<td style="width:12%;">';
                gridContent += currentVariant.colour.text
                gridContent += '</td>';

                gridContent += '<td style="width:12%;">';
                gridContent += currentVariant.size.text
                gridContent += '</td>';

                gridContent += '<td style="width:18%;">';
                var variantSKU = $(manufacturerSKU).val() + i.toLocaleString('en-US', { minimumIntegerDigits: 3, useGrouping: false })
                var escapedSKU = htmlEncode(variantSKU);
                gridContent += '<input name="" IsUnique="null" type="text" value="' + escapedSKU + '" id="SupplierSKU_' + i + '" onchange="BackOffice.Utils.CheckUniqueSKU(this.value, null, this.id, true, true);" />'
                gridContent += '</td>';

                gridContent += '<td style="width:20%;">';
                var variantName = resolveShortDescription($(shortDescription).val(), getAttributeDescriptionName(currentVariant.colour.text), getAttributeDescriptionName(currentVariant.size.text));
                var escapedVariant = htmlEncode(variantName);
                gridContent += '<input name="" type="text" value="' + escapedVariant + '" id="ShortDescription" />  '
                gridContent += '</td>';

                gridContent += '<td style="width:14%;">';
                var supplierBuyPriceEx = parseFloat($(supplierBuyEx).val() || $(priceEx).val() || 0);
                gridContent += '<input name="SupplierBuyEx_' + i + '" type="text" value="' + supplierBuyPriceEx + '" id="SupplierBuyEx_' + i + '" onkeyup="this.value = BackOffice.Utils.LimitTo2DecimalPlaces(this.value);" onblur="BackOffice.StyleProductCreateModal.CalculateVariantsTotals(event)" class="add-variants-supplier-buy-ex" style="-webkit-text-fill-color: black; color: black !important;">'
                gridContent += '</td>';

                gridContent += '<td style="width:12%;">';
                var sellPriceInc = $(fixedPrice).val();
                gridContent += '<input name="SellPriceInc_' + i + '" type="text" value="' + sellPriceInc + '" id="SellPriceInc_' + i + '" onkeyup="this.value = BackOffice.Utils.LimitTo2DecimalPlaces(this.value);" onblur="BackOffice.StyleProductCreateModal.CalculateVariantsTotals(event)" style="text-align:right">'
                gridContent += '</td>';

                gridContent += '</tr>';
            }

            // footer
            gridContent += '<tr>';
            gridContent += '<td align="right" colspan="5" style="font-weight:bold;">Total</td>'
            gridContent += '<td align="right" style="font-weight:bold;">$0.00</td>'
            gridContent += '<td align="right" style="font-weight:bold;">$0.00</td>'
            gridContent += '</tr>';

            $(addVariantsGridBodyId).append(gridContent);

            calculateVariantsTotalsImpl(5);
            calculateVariantsTotalsImpl(6);
        }
    }

    var loadAdditionalDetailsStep = function () {
        if (validateStyleConfiguration()) {
            openAdditionalDetailsStep();
            loadCustomAttributes();
            loadShopifyChannels();
        }
    }

    var openAddVariantsStep = function () {
        $(configureStylesStep).attr("hidden", true);
        $(additionalDetailsStep).attr("hidden", true);
        $(addVariantsStep).attr("hidden", false);
        $(modalSelector + ' .modal-title').html('Configure Variants');
        configureAddVariantsModalValidation();
    };

    var openAdditionalDetailsStep = function () {
        $(additionalDetailsStep).attr("hidden", false);
        $(configureStylesStep).attr("hidden", true);
        $(addVariantsStep).attr("hidden", true);
        $(modalSelector + ' .modal-title').html('Additional Details');
    };

    var openConfigureStylesStep = function () {
        initializeSelects();
        $(configureStylesStep).attr("hidden", false);
        $(addVariantsStep).attr("hidden", true);
        $(additionalDetailsStep).attr("hidden", true);
        $(modalSelector + ' .modal-title').html('Configure Style');

        $(markupTargetRadio).trigger("change");
        $(fixedPriceRadio).trigger("change");
        $(supplierBuyEx).trigger("keyup");

        initialVariantsPatternId = $(variantsPatternSelect).val();
        initialManufacturerSKU = $(manufacturerSKU).val();
        initialShortDescription = $(shortDescription).val();
        initialSellPrice = $(fixedPrice).val();
        initialSupplierBuy = $(supplierBuyEx).val();

        $(markupTarget).trigger("keyup");

    };

    var calculateVariantsTotals = function (e) {
        var columnIndex = e.target.parentElement.cellIndex;
        calculateVariantsTotalsImpl(columnIndex);
    }

    var calculateVariantsTotalsImpl = function (columnIndex) {
        var table = $(addVariantsGridBodyId)[0], sumVal = 0;

        for (var i = 1; i < table.rows.length - 1; i++) {
            sumVal += parseFloat(table.rows[i].cells[columnIndex].childNodes[0].value);
        }
        $(addVariantsGridBodyId + " tr:last td:eq(" + (columnIndex - 4) + ")").html('$' + sumVal.toFixed(2));
        
    }

    var validateVariants = function () {
        var table = $(addVariantsGridBodyId)[0];
        var someRowsChecked = false;

        for (var i = 1; i < table.rows.length - 1; i++) {
            var rowMessagePart = " (row " + (i) + ")"

            if (!table.rows[i].cells[columnIndexes.IsSelected].childNodes[0].checked) {
                continue;
            }

            someRowsChecked = true;

            if (!table.rows[i].cells[columnIndexes.SupplierSKU].childNodes[0].value) {
                alert("Please enter a Supplier SKU" + rowMessagePart);
                return false;
            }

            if (table.rows[i].cells[columnIndexes.SupplierSKU].childNodes[0].IsUnique == null) {
                table.rows[i].cells[columnIndexes.SupplierSKU].childNodes[0].onchange();
            }

            if (table.rows[i].cells[columnIndexes.SupplierSKU].childNodes[0].IsUnique == "false") {
                if (barcodesFeatureEnabled) {
                    alert("Supplier SKU must be unique (entered value matches existing Supplier SKU or Barcode)" + rowMessagePart);
                }
                else {
                    alert("Supplier SKU must be unique" + rowMessagePart);
                }
                return false;
            }

            if (table.rows[i].cells[columnIndexes.ShortDescription].childNodes[0].value == "") {
                alert("Please enter a Short Description" + rowMessagePart);
                return false;
            }

            if (table.rows[i].cells[columnIndexes.SupplierBuyEx].childNodes[0].value == "") {
                alert("Please enter a Supplier Buy Ex" + rowMessagePart);
                return false;
            } else if (!regExMoney.test(table.rows[i].cells[columnIndexes.SupplierBuyEx].childNodes[0].value)) {
                alert("Supplier Buy Ex must be a positive number" + rowMessagePart);
                return false;
            } else if (table.rows[i].cells[columnIndexes.SupplierBuyEx].childNodes[0].value > 99999999999999) {
                alert("Invalid Supplier Buy Ex - Exceeds Maximum Supported Value" + rowMessagePart);
                return false;
            }

            if (table.rows[i].cells[columnIndexes.SellPriceInc].childNodes[0].value == "") {
                alert("Please enter a Sell Price Inc" + rowMessagePart);
                return false;
            } else if (!regExMoney.test(table.rows[i].cells[columnIndexes.SellPriceInc].childNodes[0].value)) {
                alert("Sell Price Inc must be a positive number" + rowMessagePart);
                return false;
            }

        }

        if (!someRowsChecked) {
            alert("Please select at least one variant");
            return false;
        }
        else {
            if (!validateSkuUniquenessAmongVariants()) {
                alert("Supplier SKU must be unique among variants");
                return false;
            }
        }

        return true;
    }

    var validateSkuUniquenessAmongVariants = function () {
        var table = $(addVariantsGridBodyId)[0], tmpArr = [];

        for (var i = 1; i < table.rows.length - 1; i++) {
            if (!table.rows[i].cells[columnIndexes.IsSelected].childNodes[0].checked) {
                continue;
            }

            var sku = table.rows[i].cells[columnIndexes.SupplierSKU].childNodes[0].value;
            if (tmpArr.indexOf(sku) == -1) {
                tmpArr.push(sku);
            }
            else {
                return false;
            }
        }

        return true;
    }

    var setBuyEx = function () {
        var newVal = parseFloat($(supplierBuyEx).val());
        if (isNaN(newVal)) {
            $(priceEx).val(null);
        }
        if (newVal >= 0) {
            $(priceEx).val(newVal);
        }
        calculateAndSetPrices();
    }

    var calculateAndSetPrices = function () {
        // cogs
        var cogsValue = parseFloat(($(priceEx).val() || 0)) + parseFloat(($(directCostsEx).val() || 0))
        $(cogsEx).val(cogsValue.toFixed(2));

        // sell price
        if ($(markupTargetRadio).is(':checked')) {
            var markupTargetVal = $(markupTarget).val();

            if (markupTargetVal == '') {
                $(fixedPrice).val('');
            }
            else {
                var cogs = parseFloat($(cogsEx).val() || 0);
                var fixedPriceVal = (cogs + cogs * parseFloat(markupTargetVal) / 100.0) * (1 + defaultTaxRate);
                $(fixedPrice).val(fixedPriceVal.toFixed(2));
            }
        }
    }

    var insertAddItem = function (selector, tagFunction) {
        $(selector).html('<option></option>');
        $('<option/>', {
            value: "new_attr",
            html: "-- Add New --"
        }).appendTo(selector);

        $(selector).change(function () {
            if ($(this).val() == "new_attr") {
                $(selector).prop("selectedIndex", 0);
                tagFunction(selector, function (data) {
                    fillDropdown(selector, [data]);
                    $(selector).val(data.id);
                });
            }
        });
    }
    var showAttributeAccessDiniedModal = function () {
        $(accessDeniedCreateProductAttributeModalSelector).modal('show');
    }

    var initializeSelects = function () {
        $(addNewColourBtn).off('click').click(function (e) {
            e.preventDefault();
            if (BackOffice.options.userPermissions.userHasProductAttributesPermission) {
                backOffice.StyleProductCreateModal.CreateAttributeModal.ShowCreateColourModal('', function (result) {
                    addAndCheckItem(lbColoursId, { name: result.name, id: result.id });
                });
            }
            else {
                showAttributeAccessDiniedModal();
            }
        });
        $(addNewSizeBtn).off('click').click(function (e) {
            e.preventDefault();
            if (BackOffice.options.userPermissions.userHasProductAttributesPermission) {
                backOffice.StyleProductCreateModal.CreateAttributeModal.ShowCreateSizeModal('', function (result) {
                    addAndCheckItem(lbSizesId, { name: result.name, id: result.id });
                });
            }
            else {
                showAttributeAccessDiniedModal();
            }
        });

        if (BackOffice.options.userPermissions.userHasProductTypesPermission) {
            insertAddItem(productTypesSelect, backOffice.StyleProductCreateModal.CreateAttributeModal.ShowCreateProductTypeModal);
        }
        else {
            insertAddItem(productTypesSelect, showAttributeAccessDiniedModal);
        }

        if (BackOffice.options.userPermissions.userHasProductAttributesPermission) {
            insertAddItem(brandsSelect, backOffice.StyleProductCreateModal.CreateAttributeModal.ShowCreateBrandModal);
            insertAddItem(seasonsSelect, backOffice.StyleProductCreateModal.CreateAttributeModal.ShowCreateSeasonModal);
        }
        else {
            insertAddItem(brandsSelect, showAttributeAccessDiniedModal);
            insertAddItem(seasonsSelect, showAttributeAccessDiniedModal);
        }

        toggleLoader(true);

        var loadDataPromises = [
            getLoadSuppliersDropdownDataPromise(),
            getLoadDropdownDataPromise('getproducttypes', productTypesSelect),
            getLoadDropdownDataPromise('getproductattributevalues/' + BackOffice.Constants.SystemProductAttributes.Season, seasonsSelect),
            getLoadDropdownDataPromise('getproductattributevalues/' + BackOffice.Constants.SystemProductAttributes.Brand, brandsSelect),
            getLoadListBoxDataPromise('getproductattributevalues/' + BackOffice.Constants.SystemProductAttributes.Colour,
                                       selectedColoursListbox,
                                       lbColoursId,
                                       coloursFilterInput),
            getLoadListBoxDataPromise('getproductattributevalues/' + BackOffice.Constants.SystemProductAttributes.Size,
                                       selectedSizesListbox,
                                       lbSizesId,
                                       sizesFilterInput),
        ];

        Promise.all(loadDataPromises)
            .then(function (results) {
                toggleLoader(false);
                });
    }

    function fillDropdown(selector, data) {
        for (var i = 0; i < data.length; i++) {
            $('<option/>', {
                value: data[i].id,
                html: data[i].name,
            }).appendTo(selector);

            $(selector + " option:last")[0].setAttribute('data-sortOrder', data[i].listOrder);
        }
        sortDropDown(selector);
        $(selector).val($(selector + "SelectedValue").val())
    }

    function fillSuppliersDropdown(data) {
        for (var i = 0; i < data.length; i++) {
            $('<option/>', {
                value: data[i].supplierCode,
                html: data[i].name,
            }).appendTo(suppliersSelect);
        }

        $(suppliersSelect).val($(suppliersSelect + "SelectedValue").val())
    }

    var addAndCheckItem = function (sourceListBoxId, dataItem) {
        var lb = $find(sourceListBoxId);
        lb.trackChanges();

        var item = new Telerik.Web.UI.RadListBoxItem();
        item.set_text(dataItem.name);
        item.set_value(dataItem.id);

        lb.get_items().add(item);

        lb.commitChanges();

        lb.transferToDestination(lb.findItemByValue(dataItem.id));

        lb._updateUI()
    }

    var fillListBox = function (listBoxId, dataArray) {
        var lb = $find(listBoxId);
        if (lb) {
            lb.trackChanges();
            var count = lb.get_items().get_count();
            for (var i = 0; i < count; i++) {
                var lastItem = lb.getLastItem()
                lb.get_items().remove(lastItem)
            }

            var item = new Telerik.Web.UI.RadListBoxItem();
            item.set_text(DEFAULT_ATTR_OPTION_NAME);
            item.set_value(DEFAULT_ID);
            item.sortOrder = -1;
            lb.get_items().add(item);

            for (var i = 0; i < dataArray.length; i++) {
                var item = new Telerik.Web.UI.RadListBoxItem();
                item.set_text(dataArray[i].name);
                item.set_value(dataArray[i].id);
                item.sortOrder = dataArray[i].listOrder;
                lb.get_items().add(item);
            }

            lb.commitChanges();
        }
    }

    var snapshotDropdownSelectedValues = function () {
        $(seasonsSelect + selectHiddenInputSuffix).val($(seasonsSelect).val());
        $(productTypesSelect + selectHiddenInputSuffix).val($(productTypesSelect).val());
        $(brandsSelect + selectHiddenInputSuffix).val($(brandsSelect).val());
        $(suppliersSelect + selectHiddenInputSuffix).val($(suppliersSelect).val());
    }

    var getCurrentAESTDateTime = function() {
        var dateTime = new Date();
        var currentDate = dateTime.toLocaleString("en-US", { timeZone: "Australia/Sydney", year: "numeric", month: "2-digit", day: "2-digit" });
        var currentTime = dateTime.toLocaleString("en-US", { timeZone: "Australia/Sydney", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
        return `${currentDate} ${currentTime}`;
    }

    var saveVariants = function () {
        if (!validateVariants()) {
            return;
        }

        products = getProducts();
        currentDateTimeString = getCurrentAESTDateTime();

        adjustLoadingSpinnerPosition();
        toggleLoader(true);

        $.ajax({
            method: 'POST',
            async: false,
            data: JSON.stringify(products),
            url: baseApiPath + 'createproducts',
            contentType: 'application/json',
            success: function () {
                unbindWindowEventHandlers();
                redirectToProductSearch();
            },
            error: function (message) {
                toggleLoader(false);
                adjustLoadingSpinnerPosition(true);
                alert(message.responseJSON.exceptionMessage)
            }
        });
    }

    var getProducts = function () {
        var table = $(addVariantsGridBodyId)[0];
        var products = [];
        var selectedSalesChannels = readSelectedShopifyChannels();

        for (var i in table.rows) {
            var variantRow = table.rows[i];
            if (variantRow.className) {
                if (variantRow.cells[columnIndexes.IsSelected].childNodes[0].checked) {
                    var product = {
                        Id: null,
                        ShortDescription: variantRow.cells[columnIndexes.ShortDescription].childNodes[0].value,
                        SupplierSku: variantRow.cells[columnIndexes.SupplierSKU].childNodes[0].value,
                        Supplier: { SupplierCode: $(suppliersSelect + selectHiddenInputSuffix).val() },
                        ProductType: { Id: parseInt($(productTypesSelect + selectHiddenInputSuffix).val()) },
                        ManufacturerSku: $(manufacturerSKU).val(),
                        Attributes: [{
                            Id: BackOffice.Constants.SystemProductAttributes.Colour,
                            Value: {
                                Id: parseInt(variantRow.cells[columnIndexes.IsSelected].childNodes[1].value) || null,
                            }
                        }, {
                            Id: BackOffice.Constants.SystemProductAttributes.Size,
                            Value: {
                                Id: parseInt(variantRow.cells[columnIndexes.IsSelected].childNodes[2].value) || null,
                            }
                        },
                        ],
                        SupplierBuyEx: parseFloat(variantRow.cells[columnIndexes.SupplierBuyEx].childNodes[0].value),
                        BuyPriceEx: parseFloat($(priceEx).val()),
                        DirectCosts: parseFloat($(directCostsEx).val()) || null,
                        SellPrice: parseFloat(variantRow.cells[columnIndexes.SellPriceInc].childNodes[0].value),
                        CogsEx: parseFloat($(cogsEx).val()) || 0,
                        MarkupTarget: parseFloat($(markupTarget).val()) || null,
                        // additional details view properties (non required)
                        SupplierSku2: $(supplierSKU2).val() || null,
                        CustomProperties: [
                            {
                                Name: 'Custom1',
                                Value: $(custom1).val() || null,
                            },
                            {
                                Name: 'Custom2',
                                Value: $(custom2).val() || null,
                            },
                            {
                                Name: 'Custom3',
                                Value: $(custom3).val() || null,
                            },
                        ],
                        Weight: $(weight).val() || null,
                        Length: $(length).val() || null,
                        Breadth: $(breadth).val() || null,
                        Depth: $(depth).val() || null,
                        ShippingCubic: $(shippingCubic).val() || null,
                        Disabled: $(disabled)[0].checked,
                        RrpInc: $(rRP).val() || null,
                        WebPrice: $(webPrice).val() || null,
                        SalesChannels: selectedSalesChannels
                    };

                    // brand
                    var selectedBrand = parseInt($(brandsSelect + "SelectedValue").val()) || null;
                    if (selectedBrand) {
                        product.Attributes.push({
                            Id: BackOffice.Constants.SystemProductAttributes.Brand,
                            Value: {
                                Id: selectedBrand
                            }
                        });
                    }

                    // season
                    var selectedSeason = parseInt($(seasonsSelect + "SelectedValue").val()) || null;
                    if (selectedSeason) {
                        product.Attributes.push({
                            Id: BackOffice.Constants.SystemProductAttributes.Season,
                            Value: {
                                Id: selectedSeason
                            }
                        });
                    }

                    // add custom attributes from additional details view
                    var customAttributesTableObj = $(customAttributesTable)[0];
                    if (customAttributesTableObj.rows.length > 0) {
                        for (var j = 0; j < customAttributesTableObj.rows.length; j++) {
                            var attributeId = customAttributesTableObj.rows[j].childNodes[1].childNodes[0].value;
                            var attributeValueId = customAttributesTableObj.rows[j].childNodes[1].childNodes[2].value;
                            if (attributeId && attributeValueId) {
                                product.Attributes.push({
                                    Id: parseInt(attributeId),
                                    Value: {
                                        Id: parseInt(attributeValueId)
                                    }
                                });
                            }
                        }
                    }

                    product.Attributes = product.Attributes.filter(a => !!a.Value.Id && a.Value.Id !== DEFAULT_ID);

                    products.push(product);
                }
            }
        }

        return products;
    }

    var sortDropDown = function (selector) {
        $(selector).html($(selector + " option").sort(function (a, b) {
            var aSortOrder = parseInt(a.getAttribute('data-sortOrder'));
            var bSortOrder = parseInt(b.getAttribute('data-sortOrder'));

            aSortOrder = isNaN(aSortOrder) ? null : aSortOrder;
            bSortOrder = isNaN(bSortOrder) ? null : bSortOrder;

            if ((a.text.toUpperCase() == b.text.toUpperCase() && aSortOrder == bSortOrder) ||
                (a.value == 'new_attr' || b.value == 'new_attr') || (a.value == '' || b.value == '')) {
                return 0;
            }

            if ((aSortOrder == null && bSortOrder != null) || aSortOrder > bSortOrder) {
                return 1;
            }

            if (aSortOrder < bSortOrder) {
                return -1;
            }

            return a.text.toUpperCase() < b.text.toUpperCase() ? -1 : 1;
        }))
    }

    var filterListBox = function (listBoxId, filterStr) {
        if (filterStr != undefined && filterStr != '') {
            $find(listBoxId).get_items().forEach(function (element) {
                if (element._element.innerText.toUpperCase().startsWith(filterStr.toUpperCase())) {
                    element._styles = '';
                    element._element.style.display = 'block'
                }
                else {
                    element._styles = 'display: none;';
                    element._element.style.display = 'none'
                }
            });
        } else {
            $find(listBoxId).get_items().forEach(function (element) {
                element._styles = '';
                element._element.style.display = 'block'
            });
        }
    }

    var filterColours = function (filterStr) {
        filterListBox(lbColoursId, filterStr);
    }

    var filterSizes = function (filterStr) {
        filterListBox(lbSizesId, filterStr);
    }

    var configureCreateStyleModalValidation = function () {
        $(supplierBuyEx).off('change').change(function () {
            if (isSupplierBuyExUnusuallyHigh(this.value)) {
                setWarningStyle(this)
            } else {
                setInfoStyle(this);
            }
        })
    }

    var configureAddVariantsModalValidation = function () {
        var supplierBuyExInputsArray = $(addVariantsSupplierBuyExClassSelector).toArray();

        supplierBuyExInputsArray.forEach(function (element) {
            setValidationStyles(element, supplierBuyExInputsArray);

            $(element).off('change').change(function () {
                setValidationStyles(element, supplierBuyExInputsArray);
            });
        });
    }

    var setValidationStyles = function (element, supplierBuyExInputsArray) {
        if (isSupplierBuyExUnusuallyHigh(element.value)) {
            setWarningStyle(element);
        } else {
            setInfoStyle(element);
        }

        toggleWarningSectionBasedOnSupplierBuysStyle(supplierBuyExInputsArray);
    }

    var setWarningStyle = function (element) {
        element.style.cssText += "color: red !important; -webkit-text-fill-color: red;";
    }

    var setInfoStyle = function (element) {
        element.style.cssText += "color: black !important; -webkit-text-fill-color: black;";
    }

    var validateSupplierBuyEx = function (source, args) {
        args.IsValid = !isSupplierBuyExUnusuallyHigh(args.Value);
    }

    var isSupplierBuyExUnusuallyHigh = function (supplierBuyEx) {
        return parseFloat(supplierBuyEx) > 100000000;
    }

    var toggleWarningSectionBasedOnSupplierBuysStyle = function (elements) {
        if (someElementHasWarningStyle(elements)) {
            $(addVariantsValidationSectionSelector).text(
                "One or more item’s have an unusually high Supplier Buy Price. " +
                "You may need to review and confirm this value is correct.");
        }
        else {
            $(addVariantsValidationSectionSelector).text("");
        }
    }

    var someElementHasWarningStyle = function (elements) {
        return elements.some(function (element) {
            return element.style.color === "red"
        });
    }

    function loadCustomAttributes() {
        if ($(customAttributesTable)[0] && $(customAttributesTable)[0].rows.length === 0) {
            callApi('/getproductattributes/custom',
                    function (response) {
                        renderCustomAttributes(response);
                        registerCustomAttributeEvents(response);
                        if (response.length >= $(additionalDetailsPropertiesTableSelector + " tr").length) {
                            adjustPublishToShopifyTable();
                        }
                    });
        }
    }

    function renderCustomAttributes(customAttributes) {
        this.customAttributes = customAttributes || [];
        $(customAttributesTable).html('');

        // build custom attributes
        var gridContent = '';

        for (var i = 0; i < this.customAttributes.length; i++) {
            var currentAttribute = this.customAttributes[i];
            currentAttribute.options = currentAttribute.options || [];
            gridContent += '<tr>';
            gridContent += '<td><label>' + currentAttribute.name + '</label></td>';
            gridContent += '<td><input type="hidden" value="' + currentAttribute.id + '" />';
            gridContent += '<input type="hidden" value="' + currentAttribute.name + '" />';
            gridContent += '<select id="CustomAttribute_' + currentAttribute.id + '" name="CustomAttribute_' + currentAttribute.id + '">';
            gridContent += '<option></option>';
            gridContent += '<option value="new_attr">-- Add New --</option>';
            for (var j = 0; j < currentAttribute.options.length; j++) {
                gridContent += '<option value="' + currentAttribute.options[j].id + '">' + currentAttribute.options[j].name + '</option>';
            }
            gridContent += '</select></td>'
            gridContent += '</tr>';
        }

        $(customAttributesTable).append(gridContent);
    }

    function registerCustomAttributeEvents(customAttributes) {
        this.customAttributes = customAttributes || [];

        for (var i = 0; i < this.customAttributes.length; i++) {
            var currentAttribute = this.customAttributes[i];

            $('#CustomAttribute_' + currentAttribute.id).change(function () {
                if ($(this).val() == "new_attr") {
                    var selector = '#CustomAttribute_' + $(this).prev().prev().val();
                    $(selector).prop("selectedIndex", 0);
                    if (BackOffice.options.userPermissions.userHasProductAttributesPermission) {
                        var createCustomAttributeValueModal = backOffice.StyleProductCreateModal.CreateAttributeModal.ShowCreateCustomAttributeValueModal;
                        var attributeName = $(selector).prev().val();
                        var attributeId = $(selector).prev().prev().val();
                        createCustomAttributeValueModal(selector, attributeName, attributeId, function (data) {
                            $('<option/>', {
                                value: data.id,
                                html: data.name,
                            }).appendTo(selector);

                            $(selector + " option:last")[0].setAttribute('data-sortOrder', data.listOrder);

                            sortDropDown(selector);
                            $(selector).val(data.id);
                        });
                    }
                    else {
                        $(selector).val('');
                        showAttributeAccessDiniedModal();
                    }
                }
            });
        }
    }

    function loadShopifyChannels() {
        if ($(publishToShopifyTableSelector)[0] && $(publishToShopifyTableSelector)[0].rows.length === 0) {
            callApi("shopifychannels",
                    function (salesChannels) {
                        renderShopifyChannels(salesChannels);
                    });
        }
    }

    function renderShopifyChannels(shopifyChannels) {
        this.shopifyChannels = shopifyChannels || [];
        $(publishToShopifyTableSelector).html('');
        var gridContent = '';
        for (var i = 0; i < this.shopifyChannels.length; i++) {
            var shopifyChannel = this.shopifyChannels[i];
            gridContent += '<tr>';
            gridContent += '<td class="major-row-col"><label>' + shopifyChannel.name + '.myshopify.com</label></td>';
            gridContent += '<td><input type="checkbox" value="' + shopifyChannel.id + '" /></td>';
            gridContent += '</tr>';
        }

        $(publishToShopifyTableSelector).append(gridContent);
    }

    function readSelectedShopifyChannels() {
        var selectedChannels = [];
        var publishToShopifyTableObj = $(publishToShopifyTableSelector)[0];
        if (publishToShopifyTableObj.rows.length) {
            for (var i = 0; i < publishToShopifyTableObj.rows.length; i++) {
                var shopifyChannelCheckboxNode = publishToShopifyTableObj.rows[i].childNodes[1].childNodes[0];
                if (shopifyChannelCheckboxNode.checked) {
                    selectedChannels.push({ Id: shopifyChannelCheckboxNode.value, Enabled: true });
                }
            }
        }
        return selectedChannels;
    }

    function adjustPublishToShopifyTable() {
        $(publishToShopifyContainerSelector).removeClass("remove-padding-right");
        $(publishToShopifyContainerSelector).addClass("remove-padding-left");
        const additionalPropsTableHeight = $(additionalDetailsPropertiesTableSelector).height();
        const customAttrTableHeight = $(customAttributesTable).height();
        const defaultMarginTop = 3;
        $(publishToShopifyContainerSelector).css("margin-top", `${additionalPropsTableHeight - customAttrTableHeight + defaultMarginTop}px`);
    }

    function transfer(sender, e) {
        e.set_cancel(true);
        
        e.get_items().forEach(function (item) {
            if (item._element.style.display != 'none') {
                sender.transferItem(item, e.get_sourceListBox(), e.get_destinationListBox());
            }
        });

        var id = e.get_destinationListBox()._element.id;

        if (id == lbColoursId) {
            lbColoursSort();
        }

        if (id == lbSizesId) {
            lbSizesSort();
        }
    }

    function getLoadDropdownDataPromise(endpoint, selector, initialSize = 2) {
        if ($(selector + " option").length <= initialSize) {
            return getCallApiPromise(
                endpoint,
                function (data) {
                    fillDropdown(selector, data)
                }
            );
        }

        return Promise.resolve();
    }
    
    function getLoadSuppliersDropdownDataPromise(selector) {
        if ($(selector + " option").length === 0) {
            return getCallApiPromise(
                'getposuppliers',
                function (data) {
                    fillSuppliersDropdown(data)
                }
            );
        }

        return Promise.resolve();
    }

    function getLoadListBoxDataPromise(endpoint,
                                       selectedValuesListBoxSelector, 
                                       selectingValuesListBoxSelector,
                                       listBoxFilterSelector) {
        if (!($(selectedValuesListBoxSelector + " .rlbList li").length || $(selectedValuesListBoxSelector + " .rlbList li").length)) {
            return getCallApiPromise(
                endpoint,
                function (data) {
                    fillListBox(selectingValuesListBoxSelector, data);
                    radBoxSortImpl(selectingValuesListBoxSelector, listBoxFilterSelector);
                }
            );
        }

        return Promise.resolve();
    }

    function getCallApiPromise(endpoint, successHandler) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: baseApiPath + endpoint,
                dataType: 'json',
                contentType: 'application/json; charset=UTF-8',
                success: function (data) {
                    successHandler(data);
                    resolve(data);
                },
                error: reject,
                data: null
            });
        });
        }

    function callApi(endpoint, callback) {
       $.ajax({
            url: baseApiPath + endpoint,
            dataType: 'json',
            async: true,
            data: null,
            contentType: 'application/json; charset=UTF-8',
            success: callback
        });
    }

    function redirectToProductSearch() {
        var redirectUrl = BackOffice.options.userPermissions.userHasProductSearchAndManagementPermission
            ? `/DOTNET/Admin/Reports/ProductSearchManagement.aspx?plu=${$(manufacturerSKU).val()}&dateFrom=${currentDateTimeString}&considerFilters=1`
            : `/DOTNET/Admin/Inventory/ProductSearch.aspx?plu=${$(manufacturerSKU).val()}&dateFrom=${currentDateTimeString}&considerFilters=1`;

        BackOffice.Utils.RedirectTo(redirectUrl);
    }

    function bindWindowEventHandlers() {
        $(window).bind('beforeunload', function (e) {
            if (anyInputDirty()) {
                return 'Are you sure you want to leave?';
            }
        });

        $(window).bind('unload', function (e) {
            unbindWindowEventHandlers();
        });
    }

    function unbindWindowEventHandlers() {
        $(window).unbind("beforeunload");
        $(window).unbind("unload");
    }

    function anyInputDirty() {
        var allInputs = $(modalSelector).find("input, select")
            .not(`${variantsPatternSelect}, 
                  ${cogsEx},
                  #SPOSPricingByMarkupTarget,
                  #SPOSPricingByPrice,
                  #Disabled,
                  #lbColours_ClientState,
                  #lbSizes_ClientState,
                  #lbSizesSelection_ClientState,
                  #lbColoursSelection_ClientState`);
        var anyDirty = !!(allInputs.filter(function () {
            return $(this).val() !== null
                && $(this).val() !== undefined
                && $(this).val() !== ""
        }).length);

        var variantsPatternIsNotDefault = $(variantsPatternSelect).prop("selectedIndex") !== 0;
        var cogsExIsNotDefault = $(cogsEx).val() !== "0.00";
        var anyColourSelected = !!(getSelectedColoursElements().length);
        var anySizeSelected = !!(getSelectedSizesElements().length);

        return anyDirty
            || variantsPatternIsNotDefault
            || cogsExIsNotDefault
            || anyColourSelected
            || anySizeSelected;
    }

    function toggleLoader(on) {
        BackOffice.ToggleLoader(on, undefined, ".modal-overlay");
    }

    function adjustLoadingSpinnerPosition(isDefaultPosition) {
        var spinnerHeight = 70;
        var spinnerNewTopPosition = $("#create-modal-content").height() / 2 - spinnerHeight / 2;

        var spinnerElem = $("#spinner");
        spinnerElem.css("position", isDefaultPosition ? '' : "relative");
        spinnerElem.css("top", isDefaultPosition ? '' : spinnerNewTopPosition + "px");

    }


    return $.extend(backOffice.StyleProductCreateModal, {
        Init: init,
        Open: open,
        Close: close,
        ValidateStyleConfiguration: validateStyleConfiguration,
        LoadAdditionalDetailsStep: loadAdditionalDetailsStep,
        LoadConfigureVariantsStep: loadConfigureVariantsStep,
        OpenConfigureStylesStep: openConfigureStylesStep,
        OpenAddVariantsStep: openAddVariantsStep,
        OpenAdditionalDetailsStep: openAdditionalDetailsStep,
        CalculateVariantsTotals: calculateVariantsTotals,
        SetBuyEx: setBuyEx,
        CalculateAndSetPrices: calculateAndSetPrices,
        Create: saveVariants,
        Transfer: transfer,
        FilterColours: filterColours,
        SortColours: sortColours,
        FilterSizes: filterSizes,
        SortSizes: sortSizes,
        FilterListBox: filterListBox,
        ValidateSupplierBuyEx: validateSupplierBuyEx
        });
    })();

    InitCreateAttributeModal(backOffice.StyleProductCreateModal, BackOffice.Constants.SystemProductAttributes, $);

    return backOffice.StyleProductCreateModal;

})(BackOffice || {}, jQuery);